import { useEffect, useState, useCallback } from "react";
import { getUserInvites } from "../../api/userInviteService";

export const useUserInvites = (trigger, initialPage = 1, initialLimit = 100, emptyCallback = null, initialSort = 'name', initialOrder = 'asc') => {
    const [userInvites, setUserInvites] = useState({
        data: [],
        pagination: { page: initialPage, limit: initialLimit, totalPages: 1, total: 0 },
        sort: initialSort,
        order: initialOrder,
        search: null,
    });
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    const fetchData = useCallback(
        async (page = initialPage, limit = initialLimit, append = false, search = searchTerm) => {
        setLoading(true);
        try {
            const response = await getUserInvites(page, limit, search);
            if (emptyCallback && response.data.length === 0) emptyCallback(true);
            setUserInvites(prev => {
            if (append) {
                return {
                ...response,
                data: [...(prev.data || []), ...response.data],
                };
            }
            // 🔑 Reset pagination when not appending (fresh search or initial load)
            return {
                ...response,
                pagination: { ...response.pagination, page }, 
            };
            });
            return response;
        } catch (err) {
            console.error("Failed to fetch user offices:", err);
        } finally {
            setLoading(false);
        }
        },
        [initialPage, initialLimit, searchTerm]
    );

    useEffect(() => {
        fetchData(initialPage, initialLimit, false, searchTerm);
    }, [trigger, fetchData, initialPage, initialLimit, searchTerm]);

    const loadMore = async () => {
        const nextPage = userInvites.pagination.page + 1;
        if (nextPage <= userInvites.pagination.totalPages) {
        await fetchData(nextPage, userInvites.pagination.limit, true, searchTerm);
        }
    };

    // 🔎 Called by SearchBox
    const searchFunction = async (page, keywords) => {
        setSearchTerm(keywords);
        // Reset results and pagination when searching
        await fetchData(page, userInvites.pagination.limit, false, keywords);
    };

    const resetParent = async () => {
        setSearchTerm("");
        await fetchData(initialPage, initialLimit, false, "");
    };

    return { userInvites, loading, loadMore, searchFunction, resetParent };
};